import * as actionTypes from './actionTypes'
import tasksApi from './../../api/tasks';

const tasksRequest = () => ({
  type: actionTypes.TASKS_REQUEST
});

const tasksReceive = data => ({
  type: actionTypes.TASKS_RECEIVE,
  data,
});

const tasksError = error => ({
  type: actionTypes.TASKS_ERROR,
  error,
});

export const tasksInvalidate = () => ({
  type: actionTypes.TASKS_INVALIDATE,
});

const tasksFetch = (task_type) => dispatch => {
  dispatch(tasksRequest());
  return tasksApi.getTasks(task_type).then(data => dispatch(tasksReceive(data))).catch(error => dispatch(tasksError(error)));
};

const tasksShouldFetch = state => {
  const tasksState = state;
  if (tasksState.isFetching) {
    return true;
  }
  if (!tasksState.data) {
    return false;
  }
  return tasksState.didInvalidate;
};

export const tasksFetchIfNeeded = (task_type) => (dispatch, getState) => {
  if (!tasksShouldFetch(getState().tasks)) {
    return Promise.resolve();
  }
  return dispatch(tasksFetch(task_type));
};

const tasksSetViewed = id => ({
  type: actionTypes.TASKS_SET_VIEWED,
  id
});

const taskShouldSetViewed = (state, id) => {
  const task =
    state.tasks &&
    state.tasks.data &&
    state.tasks.data.tasks &&
    state.tasks.data.tasks.length &&
    state.tasks.data.tasks.find(t => t.id === id);

  return task && !task.viewed;
};

export const tasksSetViewedIfNeeded = id => (dispatch, getState) => {
  if (!taskShouldSetViewed(getState(), id)) {
    return;
  }
  tasksApi.viewTask(id);
  dispatch(tasksSetViewed(id));
};



// WEBPACK FOOTER //
// ./src/store/tasks/actions.js